import cx from 'classnames'
import styles from './SessionsToast.module.scss'

const VARIANTS = {
  success:   { style: styles.success, icon: 'check_circle' },
  warning:   { style: styles.warning, icon: 'warning' },
  cancelled: { style: styles.neutral, icon: 'cancel' },
  error:     { style: styles.error,   icon: 'error' },
}

const SessionsToast = ({ variant = 'success', title, subtitle, onClose }) => {
  const { style, icon } = VARIANTS[variant] ?? VARIANTS.success
  return (
    <div className={cx(styles.toast, style)}>
      <span className={cx('material-symbols-outlined', styles.icon)}>{icon}</span>
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      <button type="button" className={styles.closeBtn} onClick={onClose}>
        <span className="material-symbols-outlined" style={{ fontSize: 18 }}>close</span>
      </button>
    </div>
  )
}

export default SessionsToast
